<mat-dialog-content>
  <div class="capaloader" *ngIf="loadingService"></div>
  <div
    *ngIf="!error && !loading"
    style="margin-top: 20px !important;"
    class="container-fluid app-endoso py-4"
  >
    <!-- Encabezado y Descripción -->

    <div class="title ">
      <div class="col-12">
        <h3 class="feature-title-endosos">
          SOLICITUD DE AGREGAR O CAMBIAR BENEFICIARIO.
        </h3>
      </div>
    </div>
    <div class=" py-2">
      <div class="col-12">
        <br />
        <p class="description-page-endosos">
          Ingresa los datos del beneficiario que quieres agregar o modificar.
          Una vez procesada la solicitud, se te comunicará a la brevedad.
        </p>
        <p class="description-page-endosos">
          Recuerda que, al modificar tus beneficiarios se reemplazarán tus
          beneficiarios actuales.
        </p>
      </div>
    </div>
    <!-- Encabezado y Descripción FIN -->

    <!-- divider -->
    <div class="col-12">
      <mat-divider></mat-divider>
    </div>
    <form [formGroup]="formFooter" (ngSubmit)="onSubmit()" id="formFooter">
      <div>
        <div class="row py-3">
          <!-- Formulario -->
          <div class="row">
            <div formArrayName="beneficiarios">
              <div
                *ngFor="
                  let beneficiario of formFooter.get('beneficiarios').controls;
                  let i = index
                "
              >
                <div [formGroupName]="i">
                  <!-- titulo -->
                  <div class="col-12 pb-3" style="margin-bottom: 10px;">
                    <div class="row title">
                      <div class="col-12">
                        <h3 class="feature-title-endosos">
                          Beneficiario {{ i + 1 }}
                        </h3>
                      </div>
                    </div>
                  </div>
                  <!-- Input Nombre-->
                  <div class="form-group col-md-6">
                    <div class="pd-lr-15">
                      <app-form-input-text
                        [label]="'Nombre y apellidos'"
                        [placeholder]="'Ej: Juan Perez'"
                        [prefix]="''"
                        [maxlength]="40"
                        [type]="'text'"
                        [typeNumber]="false"
                        (keypress)="textOnly($event)"
                        required
                        autocomplete="off"
                        formControlName="Nombre"
                        [messageError]="
                          !beneficiario.get('Nombre').value &&
                          NombreLostFocus[i].lostFocus
                            ? 'Ingrese Nombre'
                            : ''
                        "
                        (lostFocus)="OnLostFocus('Nombre', i)"
                      >
                      </app-form-input-text>
                    </div>
                  </div>
                  <!-- Input Rut -->
                  <div class="form-group col-md-6">
                    <div class="pd-lr-15">
                      <app-form-input-text
                        [label]="'Rut'"
                        [placeholder]="'Ej: 12.3445.678-9'"
                        [prefix]="''"
                        [maxlength]="12"
                        [type]="'text'"
                        [typeNumber]="false"
                        required
                        autocomplete="off"
                        formControlName="Rut"
                        [messageError]="
                          getValidity('Rut', i) ? 'Ingrese un RUT válido' : ''
                        "
                        (lostFocus)="validarRut(i)"
                      >
                      </app-form-input-text>
                    </div>
                  </div>

                  <!-- combobox Parentesco -->
                  <div class="form-group col-md-6 col-lg-3">
                    <div class="pd-lr-15">
                      <app-form-select
                        required
                        [label]="'Parentesco'"
                        formControlName="Parentesco"
                        [options]="parentesco"
                        [optionValue]="'name'"
                        [optionDescription]="'name'"
                        [placeholder]="'Seleccionar...'"
                        [messageError]="
                          !beneficiario.get('Parentesco').value &&
                          ParentescoLostFocus[i].lostFocus
                            ? 'Ingrese Parentesco'
                            : ''
                        "
                        (click)="OnLostFocus('Parentesco', i)"
                        ($onChange)="IsOtroParentesco(i)"
                      >
                      </app-form-select>
                    </div>
                  </div>

                  <!-- input Case "Otro" Parentesco -->
                  <div
                    class="form-group col-md-6 col-lg-3"
                    *ngIf="isOtroParentesco[i]"
                  >
                    <div class="pd-lr-15">
                      <app-form-input-text
                        [label]="'Tipo parentesco'"
                        [placeholder]="'Ej: Primo'"
                        [prefix]="''"
                        [maxlength]="20"
                        [type]="'text'"
                        [typeNumber]="false"
                        (keypress)="textOnly($event)"
                        autocomplete="off"
                        formControlName="OtroParentesco"
                        [messageError]="
                          !beneficiario.get('OtroParentesco').value &&
                          OtroParentescoLostFocus[i].lostFocus
                            ? 'Ingrese Nombre'
                            : ''
                        "
                        (lostFocus)="OnLostFocus('OtroParentesco', i)"
                      >
                      </app-form-input-text>
                    </div>
                  </div>

                  <!-- combobox Sexo -->
                  <div class="form-group col-md-6 col-lg-3">
                    <div class="pd-lr-15">
                      <app-form-select
                        required
                        [label]="'Sexo'"
                        formControlName="Sexo"
                        [options]="sexo"
                        [optionValue]="'name'"
                        [optionDescription]="'name'"
                        [placeholder]="'Seleccionar...'"
                        [messageError]="
                          !beneficiario.get('Sexo').value &&
                          SexoLostFocus[i].lostFocus
                            ? 'Ingrese Sexo'
                            : ''
                        "
                        (click)="OnLostFocus('Sexo', i)"
                      >
                      </app-form-select>
                    </div>
                  </div>

                  <!-- combobox Prioridad -->
                  <div class="form-group col-md-6 col-lg-3">
                    <div class="pd-lr-15">
                      <app-form-select
                        [label]="'Prioridad'"
                        formControlName="Prioridad"
                        [options]="prioridad"
                        [optionValue]="'value'"
                        [optionDescription]="'value'"
                        [placeholder]="'Seleccionar...'"
                        [messageError]="
                          !beneficiario.get('Prioridad').value &&
                          PrioridadLostFocus[i].lostFocus
                            ? 'Ingrese Prioridad'
                            : ''
                        "
                        (click)="OnLostFocus('Prioridad', i)"
                        (ngModelChange)="
                          cambiarPrioridad(
                            i,
                            beneficiario.get('Prioridad').value,
                            beneficiario.get('Participacion').value
                          )
                        "
                      >
                      </app-form-select>
                    </div>
                  </div>
                  <!-- Input Participacion-->
                  <div class="form-group col-md-6 col-lg-3">
                    <div class="pd-lr-15">
                      <app-form-input-text
                        [label]="'Participación'"
                        [placeholder]="'%'"
                        [prefix]="''"
                        [maxlength]="7"
                        [type]="'text'"
                        [typeNumber]="true"
                        required
                        autocomplete="off"
                        formControlName="Participacion"
                        (keypress)="numberOnly($event)"
                        (focusout)="onLostFocus('Participacion', i)"
                        [disabled]="!beneficiario.get('Prioridad').value"
                        [messageError]="
                          !beneficiario.get('Participacion').value &&
                          ParticipacionLostFocus[i].lostFocus
                            ? 'Ingrese Participación '
                            : beneficiario.get('Participacion').value &&
                              !beneficiario.get('Participacion').valid
                            ? 'Ingrese un valor válido'
                            : ''
                        "
                        (click)="OnLostFocus('Participacion', i)"
                      >
                        <!--
                        [messageError]="
                          !beneficiario.get('Participacion').value &&
                          ParticipacionLostFocus[i].lostFocus
                            ? 'Ingrese Participación'
                            : beneficiario.get('Participacion').value &&
                              !beneficiario.get('Participacion').valid
                            ? 'Ingrese un valor válido'
                            : ''
                        "
                      -->
                      </app-form-input-text>
                    </div>
                  </div>

                  <!-- Input de Direccion -->
                  <div class="form-group col-md-12 fullwidth">
                    <div class="pd-lr-15">
                      <app-form-input-text
                        [label]="'Direccion'"
                        [placeholder]="'Calle N°'"
                        [prefix]="''"
                        [maxlength]="128"
                        [type]="'text'"
                        [typeNumber]="false"
                        required
                        autocomplete="off"
                        formControlName="Direccion"
                        [messageError]="
                          !beneficiario.get('Direccion').value &&
                          DireccionLostFocus[i].lostFocus
                            ? 'Ingrese Direccion'
                            : ''
                        "
                        (lostFocus)="OnLostFocus('Direccion', i)"
                      >
                      </app-form-input-text>
                    </div>
                  </div>

                  <!-- [messageError]="getErrorMessage(form, 'RegionCodigo')" -->
                  <!-- combobox Region -->
                  <div class="form-group col-md-6">
                    <div class="pd-lr-15">
                      <app-form-select
                        required
                        [label]="'Región'"
                        formControlName="Region"
                        [options]="regiones"
                        [optionValue]="'CodigoRegion'"
                        [optionDescription]="'Nombre'"
                        [placeholder]="'Seleccionar...'"
                        ($onChange)="regionOnChange($event, i)"
                        [messageError]="
                          !beneficiario.get('Region').value &&
                          RegionLostFocus[i].lostFocus
                            ? 'Ingrese Región'
                            : ''
                        "
                        (click)="OnLostFocus('Region', i)"
                      >
                      </app-form-select>
                    </div>
                  </div>

                  <!-- [messageError]="getErrorMessage(form, 'CiudadCodigo')" -->
                  <!-- combobox Ciudad -->
                  <div class="form-group col-md-6">
                    <div class="pd-lr-15">
                      <app-form-select
                        required
                        [label]="'Ciudad'"
                        formControlName="Ciudad"
                        [options]="colCiudades[i]"
                        [optionValue]="'CodigoCiudad'"
                        [optionDescription]="'Nombre'"
                        ($onChange)="ciudadOnChange($event, i)"
                        [placeholder]="'Seleccionar...'"
                        [messageError]="
                          !beneficiario.get('Ciudad').value &&
                          CiudadLostFocus[i].lostFocus
                            ? 'Ingrese Ciudad'
                            : ''
                        "
                        (click)="OnLostFocus('Ciudad', i)"
                      >
                      </app-form-select>
                    </div>
                  </div>
                  <!-- combobox Comuna -->

                  <!-- [messageError]="getErrorMessage(form, 'ComunaCodigo')" -->
                  <div class="form-group col-md-6">
                    <div class="pd-lr-15">
                      <app-form-select
                        [label]="'Comuna'"
                        formControlName="Comuna"
                        required
                        [options]="colComunas[i]"
                        [optionValue]="'CodigoComuna'"
                        [optionDescription]="'Nombre'"
                        [placeholder]="'Seleccionar...'"
                        [messageError]="
                          !beneficiario.get('Comuna').value &&
                          ComunaLostFocus[i].lostFocus
                            ? 'Ingrese Comuna'
                            : ''
                        "
                        (click)="OnLostFocus('Comuna', i)"
                      >
                      </app-form-select>
                    </div>
                  </div>
                  <!-- Boton Eliminar -->

                  <div class="row py-2" *ngIf="cantidadBeneficiarios > 1">
                    <div class="col-sm-12">
                      <button
                        mat-flat-button
                        color="primary"
                        type="button"
                        class="btn  btn-primary btn-primary-vs"
                        style="margin-left: 1.5%; color:white; cursor: pointer;"
                        (click)="deleteBeneficiario(i)"
                      >
                        Eliminar Beneficiario <i class="fa fa-minus-circle"></i>
                      </button>
                    </div>
                  </div>
                  <!-- Mensaje de -->

                  <!-- Boton Agregar -->
                  <div
                    class="row py-2"
                    *ngIf="
                      i + 1 === formFooter.get('beneficiarios').controls.length
                    "
                  >
                    <div
                      class="mat-error position-message-prioridad"
                      *ngIf="!ValidaPrioridades"
                    >
                      Valida que la partipación de tus beneficiarios sume 100%
                    </div>
                    <div class="col-sm-12 flex">
                      <button
                        mat-flat-button
                        color="primary"
                        class="btn  btn-primary btn-primary-vs"
                        type="button"
                        style="margin-right: 3.5%; margin-top: 15px; margin-bottom: 15px; cursor: pointer;"
                        (click)="BrnAgregaBeneficiario()"
                        [disabled]="!validaFormularios(i)"
                      >
                        Agregar otro Beneficiario
                      </button>
                    </div>
                  </div>
                </div>
                <!-- divider -->
                <div class="col-12">
                  <mat-divider></mat-divider>
                </div>
              </div>
            </div>

            <!-- </form> -->

            <!-- divider -->
            <div class="col-12" style="margin-bottom: 10px;">
              <mat-divider></mat-divider>
            </div>
            <div class="row">
              <div class="pd-lr-15">
                <p>
                  Ingresa tus datos de contacto para comunicarnos en caso que
                  sea necesario.
                </p>
              </div>
            </div>
            <div class="form-group col-md-6">
              <div class="pd-lr-15 positionRelative ">
                <app-form-input-text
                  [label]="'Correo electrónico'"
                  [placeholder]="'Ej: juanperez@gmail.com'"
                  [prefix]="''"
                  [maxlength]="200"
                  [type]="'text'"
                  [typeNumber]="false"
                  autocomplete="off"
                  [disabled]="true"
                  [innerValue]="emailDeposito"
                >
                  >
                </app-form-input-text>
                <svg-icon
                  *ngIf="mostrarInfo"
                  class="icon svgEmail"
                  app-tooltip="{{ info }}"
                  position="right"
                  src="../../assets/icons/information-right-white.svg"
                  [svgStyle]="{
                    'width.rem': 0.93,
                    'height.rem': 0.87,
                    position: 'relative',
                    'left.rem': 0.15
                  }"
                >
                </svg-icon>
              </div>
            </div>
            <!-- Input Telefono -->

            <div class="form-group col-md-6">
              <div class="pd-lr-15">
                <app-form-input-text
                  [label]="'Teléfono de contacto'"
                  [placeholder]="'912345678'"
                  [prefix]="'+56'"
                  [maxlength]="9"
                  [typeNumber]="true"
                  required
                  autocomplete="off"
                  formControlName="telefono"
                  (lostFocus)="OnLostFocus('Telefono', 0)"
                  [messageError]="
                    !formFooter.get('telefono').value && TelefonoLostFocus
                      ? 'Ingrese Teléfono de contacto'
                      : formFooter.get('telefono').value &&
                        !formFooter.get('telefono').valid
                      ? 'Ingrese un teléfono válido'
                      : ''
                  "
                >
                </app-form-input-text>
              </div>
            </div>
            <!-- divider -->
            <div class="col-12">
              <mat-divider></mat-divider>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="row py-2">
      <app-mini-loader *ngIf="loadingService"></app-mini-loader>
      <app-empty-data-message
        *ngIf="formularioSinProblemas"
        message="Su solicitud ha sido registrada con éxito."
      >
      </app-empty-data-message>
    </div>
    <!-- Botones -->
    <div class="row py-2" style="margin-top: 10px;">
      <div class="col-sm-12 text-center">
        <button
          style="font-size: 14px !important;"
          mat-flat-button
          type="button"
          class="btn btn-gray"
          (click)="onClose()"
        >
          Cancelar
        </button>
        <button
          mat-flat-button
          color="primary"
          class="btn"
          style="font-size: 14px !important;"
          type="submit"
          name="action"
          (click)="onSubmit()"
          [disabled]="
            !formFooter.valid ||
            !formFooter.dirty ||
            sumaParticipacion != sumaGrupos.length * 100 ||
            !sumatoriasValidas ||
            !botonSolicitarHabilitado
          "
        >
          Solicitar
        </button>
      </div>
    </div>
  </div>
</mat-dialog-content>
